import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import commonSlice from './sliceCreators/commonSlice';
import filtersSlice from './sliceCreators/filtersSlice';
import launchesSlice from './sliceCreators/launchesSlice';
import projectsSlice from './sliceCreators/projectsSlice';
import searchSlice from './sliceCreators/searchSlice';
import sortingSlice from './sliceCreators/sortingSlice';

const store = configureStore({
  reducer: {
    search: searchSlice,
    searchSorting: sortingSlice,
    filters: filtersSlice,
    projects: projectsSlice,
    common: commonSlice,
    launches: launchesSlice,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export type AppThunk = ThunkAction<void, RootState, unknown, Action>;

export default store;
